import React, { Component } from 'react';
import styled from 'styled-components';

import Link from '../Link';
import { Field as InputField, Label, LabelText, ErrorMessage, Required } from './Input';
import Checkbox from './Checkbox';

const Button = styled(Link)`
  color: ${p => p.theme.colors.primary};
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: inline;
  border: none;
  text-decoration: underline;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export const FormContext = React.createContext({
    onFieldChange: () => { },
    registerField: () => { },
    unRegisterField: () => { },
    values: {},
    errors: {},
    fieldMissingMessage: '',
    fields: {},
    disabled: false,
});

export default class NewForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: props.values || {},
            errors: props.errors || {},
            fieldMissingMessage: props.fieldMissingMessage || 'Dette feltet er obligatorisk',
            fields: {},
            disabled: props.disabled,
        };
    }

    render() {
        let { values, errors, fieldMissingMessage, fields } = this.state;
        let { onChange, onSubmit, children, disabled, ...props } = this.props;

        return <FormContext.Provider
            value={{
                onFieldChange: (key, value) => {
                    values[key] = value;

                    this.setState({
                        values
                    });

                    onChange && onChange(values, { key, value });
                },
                registerField: (fieldProps) => {
                    let { fields } = this.state;

                    fields[fieldProps.name] = fieldProps;

                    this.setState({
                        fields
                    });
                },
                unRegisterField: (fieldProps) => {
                    let { deleteOnUnMout } = this.props;
                    let { fields } = this.state;

                    if (!deleteOnUnMout) {
                        return;
                    }

                    delete (fields[fieldProps.name]);

                    this.setState({
                        fields
                    });
                },
                values,
                errors,
                fieldMissingMessage,
                fields,
                disabled: disabled || this.state.disabled,
            }}
        >
            <form
                {...props}
                onSubmit={(e) => {
                    e.preventDefault();

                    let { values, fields, fieldMissingMessage } = this.state;
                    let errors = {};
                    let hasError = false;

                    Object.keys(fields).forEach((key) => {
                        let field = fields[key];

                        if (field.required && (!values[key] || Array.isArray(values[key]) && !values[key].length)) {
                            hasError = true;
                            errors[key] = field.fieldMissingMessage || fieldMissingMessage;

                            return;
                        }

                        if (field.validate) {
                            let error = field.validate(values[key]);

                            if (error) {
                                hasError = true;
                                errors[key] = error;

                                return;
                            }
                        }
                    });

                    this.setState({ errors });

                    if (hasError) {
                        return;
                    }

                    onSubmit && onSubmit(values);
                }}
            >
                {children}
                <input
                    style={{
                        height: '1px',
                        width: '1px',
                        opacity: '0',
                        position: 'absolute',
                        left: '-99999px',
                    }}
                    type="submit"
                />
            </form>
        </FormContext.Provider>;
    }
}

class Field extends Component {
    static contextType = FormContext;

    constructor(props, context) {
        super(props);

        this.state = {
            value: context.values[props.name],
        };
    }

    componentDidMount() {
        // TODO: Register field
        this.context.registerField({
            validate: this.validate,
            ...this.props,
        });
    }

    componentWillUnmount() {
        // TODO: Un-register field
        this.context.unRegisterField(this.props);
    }

    onChange(value) {
        this.context.onFieldChange(this.props.name, value);

        this.props.onChange && this.props.onChange(value);
    }

    renderField() {
        return <div>Override me!</div>;
    }

    render() {
        return this.renderField();
    }
}

export class TextField extends Field {
    renderField() {
        let { hideLabel, label, required, name, error, ...props } = this.props;

        error = error || this.context.errors[name];

        return <Label>
            <LabelText hideLabel={hideLabel}>
                {label} {required && <Required>*</Required>}
            </LabelText>
            <InputField
                {...props}
                name={name}
                hasError={!!error}
                disabled={this.context.disabled}
                defaultValue={this.context.values[name]}
                onChange={e => this.onChange(e.target.value)}
            />
            {error && <ErrorMessage>{error}</ErrorMessage>}
        </Label>;
    }
}

export class CheckboxGroupField extends Field {
    renderField() {
        let { hideLabel, label, required, name, error, options, ...props } = this.props;

        error = error || this.context.errors[name];

        var value = this.context.values[name] || [];

        return <Label>
            <LabelText hideLabel={hideLabel}>
                {label} {required && <Required>*</Required>}
            </LabelText>

            {Object.keys(options).map(key => <div
                key={key}
            >
                <Checkbox
                    value={key}
                    label={options[key]}
                    checked={value.indexOf(key) > -1}
                    disabled={this.context.disabled}
                    onChange={(e) => {
                        if (value.indexOf(key) > -1) {
                            value.splice(value.indexOf(key), 1);
                        } else {
                            value.push(key);
                        }

                        this.onChange(value);
                    }}
                />
            </div>)}

            {error && <ErrorMessage>{error}</ErrorMessage>}
        </Label>;
    }
}

export class PrivacyPolicyField extends Field {
    renderField() {
        let { hideLabel, label, required, name, error, ...props } = this.props;

        error = error || this.context.errors[name];

        return <Label>
            <Checkbox
                name={name}
                label={<span>
                    Jeg bekrefter at jeg godkjenner{' '}
                    <Button to="/personvernerklaering/">
                        personvernerklæringen
                    </Button>{' '}
                    til denne nettsiden.
                </span>}
                checked={this.context.values[name]}
                onChange={() => this.onChange(!this.context.values[name])}
                disabled={this.context.disabled}
            />
            {error && <ErrorMessage>{error}</ErrorMessage>}
        </Label>;
    }
}
